















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import VueGtag from "vue-gtag";
import VueRouter from 'vue-router';
import hubService from "@/services/hub.service";
import { toAppHttpError } from "@/core/HttpResources/httpError";

const router = new VueRouter({
  routes: [
    { name: 'Home', path: '/' },
    { name: 'login', path: '/login' },
  ]
});

Vue.use(VueGtag, {
  config: { id: "UA-127161372-2" }
}, router);

@Component({
  components: {},
})
export default class App extends Vue {
  email = "";
  password = "";
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  created() {
    this.registerHttpInterceptor();
    if (this.isLoggedIn) {
      hubService.start();
    }
  }

  @Watch("isLoggedIn")
  onIsLoggedInChanged(isLoggedIn: boolean) {
    if (isLoggedIn) {
      hubService.start();
    }
  }

  registerHttpInterceptor() {
    var self = this as any;
    self.$http.interceptors.response.use(
      (response: any) => response,
      (err: any) => {
        const appError = toAppHttpError(err);

        if (appError.status === 401 && this.isLoggedIn) {
          this.$store.dispatch("logout");
        }

        return Promise.reject(appError);
      }
    );
  }
}
